// extracted by mini-css-extract-plugin
export default {"due-amount":"wOGW-","dueAmount":"wOGW-"};